import { render, staticRenderFns } from "./hot_spot_type.vue?vue&type=template&id=139b02cd&scoped=true"
import script from "./hot_spot_type.vue?vue&type=script&lang=js"
export * from "./hot_spot_type.vue?vue&type=script&lang=js"
import style0 from "./hot_spot_type.vue?vue&type=style&index=0&id=139b02cd&prod&scoped=true&lang=less"
import style1 from "./hot_spot_type.vue?vue&type=style&index=1&id=139b02cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b02cd",
  null
  
)

export default component.exports